/*
 Note:
 This component is included directly into the sources of this project to simplify the
 build process.

 License:
 Copyright 2019, Indoqa Software Design und Beratung GmbH

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import {StyleConfig, StyleSearchInputComponent} from './SearchInput.types'

export const DEFAULT_STYLE_CONFIG: StyleConfig = {
  borderRadius: 8,
  borderStyle: '1px solid #dfe1e5',
  comboboxBackgroundColor: '#FFF',
  highlightColor: '#EEE',
  itemPaddingBottom: '0.25rem',
  itemPaddingTop: '0.25rem',
  iconContainerWidth: 26,
  menuBackgroundColor: '#FFF',
  menuPaddingBottom: '0.5rem',
  menuPaddingTop: '0.5rem',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
  shadow: true,
  shadowCombobox: '0 1px 6px 0 rgba(32,33,36,0.28)',
  shadowMenu: '0 1px 6px 0 rgba(32,33,36,0.28)',
  showIconIcons: true,
}

const styleInputHeight = 40

export const styleContainer: StyleSearchInputComponent = (config, props) => ({
  // position: 'relative',
  height: '100%',
  margin: 0,
  padding: 0,
  bottom: 0,
})

export const styleInput: StyleSearchInputComponent = (config, props) => ({
  flexGrow: 1,
  border: 0,
  backgroundColor: 'transparent',
  height: styleInputHeight,
  outline: 'none',
})

export const styleCombobox: StyleSearchInputComponent = (config, props) => ({
  display: 'inline-flex',
  width: '100%',
  alignItems: 'center',
  paddingTop: 1,
  paddingRight: config.paddingRight,
  paddingBottom: 1,
  paddingLeft: config.paddingLeft,
  borderTop: config.borderStyle,
  borderRight: config.borderStyle,
  borderBottom: props.showCompletions ? 'none' : config.borderStyle,
  borderLeft: config.borderStyle,
  borderTopRightRadius: config.borderRadius,
  borderTopLeftRadius: config.borderRadius,
  borderBottomRightRadius: props.showCompletions ? 0 : config.borderRadius,
  borderBottomLeftRadius: props.showCompletions ? 0 : config.borderRadius,
  boxShadow: config.shadow && props.active ? config.shadowCombobox : 'none',
  backgroundColor: config.comboboxBackgroundColor,
})

export const styleMenu: StyleSearchInputComponent = (config, props) => ({
  // position: 'absolute',
  width: '100%',
  // maxHeight: '600',
  height: `calc(100% - ${styleInputHeight + 10}px)`,
  overflowY: 'scroll',
  listStyleType: 'none',
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: props.showCompletions ? config.menuPaddingBottom : 0,
  paddingTop: props.showCompletions ? config.menuPaddingTop : 0,
  backgroundColor: config.menuBackgroundColor,
  zIndex: 99,
  borderBottom: props.showCompletions ? config.borderStyle : 'none',
  borderLeft: props.showCompletions ? config.borderStyle : 'none',
  borderRight: props.showCompletions ? config.borderStyle : 'none',
  borderTop: props.showCompletions ? config.borderStyle : 'none',
  borderBottomRightRadius: config.borderRadius,
  borderBottomLeftRadius: config.borderRadius,
  boxShadow: config.shadow ? config.shadowMenu : 'none',
})

export const styleMenuItem: StyleSearchInputComponent = (config, props) => ({
  paddingTop: config.itemPaddingTop,
  paddingRight: config.paddingRight,
  paddingBottom: config.itemPaddingBottom,
  paddingLeft: config.paddingLeft,
  cursor: 'pointer',
})

export const styleIconContainer: StyleSearchInputComponent = (config, props) => ({
  display: config.showIconIcons ? undefined : 'none',
  width: config.showIconIcons ? 26 : 0,
})
